/**
 * 本地存储操作模块
 */
/**
 * 存储
 * @param {string} item localStorage.setItem需要的 key
 * @param {any} value localStorage.setItem需要的 value
 */
export const setItem = (item, value) => {
  // 将数组或对象类型的数据转换为 JSON 格式字符串进行存储
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(item, value)
}

/**
 * 获取
 * @param {string} key 获取本地数据的 key 名
 */
export const getItem = key => {
  const data = window.localStorage.getItem(key)
  try {
    // 如果真的是 JSON 格式的字符串，JSON.parse(data) 不会报错
    // 如果不是 JSON 格式的字符串，JSON.parse(data) 报错 从而执行 catch 内部代码
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}

/**
 * 移除
 * @param {string} key localStorage.removeItem需要的 key
 */
export const removeItem = key => {
  window.localStorage.removeItem(key)
}
